import { useCallback, useEffect, useState } from 'react';

/** Matches `--vo2-slide-up-exit-duration` (400ms) + small buffer */
export const SLIDE_UP_EXIT_MS = 420;

/**
 * Keeps overlay mounted while exit animation plays.
 * Pair with `vo2-slide-up-*--closing` CSS classes.
 */
export function useSlideUpPresence(open: boolean, exitMs = SLIDE_UP_EXIT_MS) {
  const [mounted, setMounted] = useState(open);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (open) {
      setMounted(true);
      setClosing(false);
      return;
    }
    if (!mounted) return;
    setClosing(true);
    const timer = window.setTimeout(() => {
      setMounted(false);
      setClosing(false);
    }, exitMs);
    return () => window.clearTimeout(timer);
  }, [open, mounted, exitMs]);

  const requestClose = useCallback(
    (onClose: () => void) => {
      if (closing) return;
      onClose();
    },
    [closing],
  );

  return { mounted, closing, requestClose };
}
